import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getOuterApiConfigsById } from 'src/api/outerApiConfigs/{id}';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends Omit<SelectProps<string>, 'id'> {
    id?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { id, ...restProps } = props;

    const [responseOptions, setResponseOptions] = useState<{ label: string; value: string }[]>([]);

    useRequest(
        () =>
            getOuterApiConfigsById({
                segments: {
                    id: id!,
                },
            }),
        {
            ready: !!id,
            refreshDeps: [id],
            onSuccess: (res) => {
                setResponseOptions(
                    (res.data?.responseBodyList || [])?.map((item) => {
                        return {
                            label: item.key!,
                            value: item.value!,
                        };
                    })
                );
            },
        }
    );

    return (
        <Select
            options={responseOptions}
            placeholder={/* 请选择返回参数 */UdeskLocales['current'].components.outerApiConfigsResponseSelect.index.pleaseSelectAReturnParameter}
            showSearch
            filterOption={(input, option) =>
                ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())
            }
            {...restProps}
        />
    );
});

export default Template;
